import { Component, OnInit } from "@angular/core";
import { ErrorInfo, ErrorInfoResolver } from "@scisys-uim/uim-common";
import { AmmunitionStockEventService } from "assets-service";
import { ActivatedRoute } from "@angular/router";
import { AmmunitionStockEventType } from "assets-model";

const TOKEN_PARAM_KEY = 'acknowledgementToken';

@Component({
    selector: 'app-ranger-acknowledge-issue-return',
    templateUrl: './acknowledge-issue-return.component.html',
    styleUrls: ['./acknowledge-issue-return.component.scss']
})
export class AmmunitionAcknowledgeIssueReturnComponent implements OnInit {

    acknowledged: boolean;
    error: ErrorInfo;
    jwt: string;
    eventType: AmmunitionStockEventType;

    constructor(
        protected ammunitionStockEventService: AmmunitionStockEventService,
        protected errorInfoResolver: ErrorInfoResolver,
        protected route: ActivatedRoute
    ) { 
        this.eventType = route.snapshot.data['eventType'] as AmmunitionStockEventType;
    }


    ngOnInit(): void {
        const searchParams = new URLSearchParams(window.location.search);
        this.jwt = searchParams.get(TOKEN_PARAM_KEY);
    }

    isAcknowledgeAmmunitionIssueReturnEnabled() {
        return this.jwt != null && this.acknowledged == null && this.error == null;
    }

    acknowledgeAmmunitionIssueReturn() {
        var serviceCall = this.eventType === "Issue"?
            this.ammunitionStockEventService.acknowledgeIssue(this.jwt) :
            this.ammunitionStockEventService.acknowledgeReturn(this.jwt);
        serviceCall.subscribe(result => {
            this.acknowledged = true;
        }, error => {
            this.error = this.errorInfoResolver.toErrorInfo(error);
            throw error;
        }
        );
    }
}